import { PropsWithChildren } from 'react';

import { Clear, Edit } from '@mui/icons-material';
import { Box, ButtonGroup, IconButton, Stack, SxProps, Theme } from '@mui/material';

type GenericPropertyInputProps<T> = PropsWithChildren & {
	disabled?: boolean;
	value?: T | undefined;
	onValueChange: (value: T | undefined) => void;
	onOpen: () => void;
	contentSx?: SxProps<Theme>;
};

export default function GenericPropertyInput<T>({ value, onValueChange, disabled, onOpen, children, contentSx }: GenericPropertyInputProps<T>) {
	return (
		<Stack direction="row" spacing={0.5} sx={{ width: '100%' }}>
			<Box
				component="div"
				onClick={
					disabled
						? undefined
						: (e) => {
								// Ignore clicks that originated inside a portal (e.g. Dialog, Popover) — those bubble
								// through the React tree but their real DOM target is outside this Box.
								if ((e.currentTarget as HTMLElement).contains(e.nativeEvent.target as Node)) {
									onOpen();
								}
							}
				}
				sx={{ flexGrow: 1, overflow: 'auto', width: '100%', cursor: disabled ? 'default' : 'pointer', ...contentSx }}
			>
				{children}
			</Box>
			<ButtonGroup
				size="small"
				sx={{
					'& .MuiIconButton-root': {
						padding: '4px',
						minWidth: 'auto',
					},
				}}
			>
				<IconButton size="small" title="Clear" onClick={() => onValueChange(undefined)} disabled={disabled || !value}>
					<Clear fontSize="small" />
				</IconButton>
				<IconButton size="small" title="Edit" onClick={onOpen} disabled={disabled}>
					<Edit fontSize="small" />
				</IconButton>
			</ButtonGroup>
		</Stack>
	);
}
